/**
 * @generated SignedSource<<f72960cdc7832132007630296bea894d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type createOidcIdentityProviderMutation$variables = {
  clientId: string;
  clientSecret?: string | null;
  connections: ReadonlyArray<string>;
  metadataJson?: any | null;
  metadataUrl: string;
  name: string;
  organizationNodeId: string;
  usePkce: boolean;
  uuid?: any | null;
};
export type createOidcIdentityProviderMutation$data = {
  readonly createOidcIdentityProvider: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly identityProviderConfiguration: {
      readonly id: string;
      readonly name: string;
      readonly oidcCallbackUrl: string | null;
      readonly oidcInitiateLoginUrl: string | null;
      readonly providerType: identityprovidertype;
      readonly uuid: string;
    } | null;
  } | null;
};
export type createOidcIdentityProviderMutation = {
  response: createOidcIdentityProviderMutation$data;
  variables: createOidcIdentityProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clientId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clientSecret"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadataJson"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadataUrl"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationNodeId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "usePkce"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v9 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "clientId"
  },
  {
    "kind": "Variable",
    "name": "clientSecret",
    "variableName": "clientSecret"
  },
  {
    "kind": "Variable",
    "name": "metadataJson",
    "variableName": "metadataJson"
  },
  {
    "kind": "Variable",
    "name": "metadataUrl",
    "variableName": "metadataUrl"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "organizationNodeId",
    "variableName": "organizationNodeId"
  },
  {
    "kind": "Variable",
    "name": "usePkce",
    "variableName": "usePkce"
  },
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "IdentityProviderConfiguration",
  "kind": "LinkedField",
  "name": "identityProviderConfiguration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oidcCallbackUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oidcInitiateLoginUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createOidcIdentityProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "CreateOidcIdentityProvider",
        "kind": "LinkedField",
        "name": "createOidcIdentityProvider",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "createOidcIdentityProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "CreateOidcIdentityProvider",
        "kind": "LinkedField",
        "name": "createOidcIdentityProvider",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "identityProviderConfiguration",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "IdentityProviderConfigurationEdge"
              }
            ]
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d3848ec7330dd6748fc2cbd3e2d83d4f",
    "id": null,
    "metadata": {},
    "name": "createOidcIdentityProviderMutation",
    "operationKind": "mutation",
    "text": "mutation createOidcIdentityProviderMutation(\n  $organizationNodeId: ID!\n  $name: String!\n  $clientId: String!\n  $clientSecret: String\n  $usePkce: Boolean!\n  $metadataUrl: String!\n  $metadataJson: JSONString\n  $uuid: UUID\n) {\n  createOidcIdentityProvider(organizationNodeId: $organizationNodeId, name: $name, clientId: $clientId, clientSecret: $clientSecret, usePkce: $usePkce, metadataUrl: $metadataUrl, metadataJson: $metadataJson, uuid: $uuid) {\n    identityProviderConfiguration {\n      id\n      uuid\n      name\n      providerType\n      oidcCallbackUrl\n      oidcInitiateLoginUrl\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "304d6e97387a7de4fa8d4296ab390120";

export default node;
